import React from "react";
import ajax from "./../lib/ajax.js";
import moment from 'moment';
import context from "./../lib/context.js";
import PeopleDocumentTitle from "./people-document-title.jsx";
import { Fragment } from "react";

export default class PeopleDocument extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pendingDocumentLogs:[]
        }
        this.countGridLoading = 0;
        this.getPendingDocumentLogs = this.getPendingDocumentLogs.bind(this);
        this.toggleLoadingDialog = this.toggleLoadingDialog.bind(this);

    }
    componentDidMount() {
        this.getPendingDocumentLogs();
    }

    getPendingDocumentLogs() {
        let url = `get-pending-documents`;
        let self = this;
        self.toggleLoadingDialog(true);

        ajax.api()
        .get(url)
        .then(result => {
            self.setState({
                pendingDocumentLogs: result.data             
            }, ()=> self.toggleLoadingDialog(false));           
        }).catch(function (err) {
            let data = err.response? err.response.data : err;
            context.message({
                show: true,
                type: "error", 
                message: data.exceptionMessage || data.message,
                buttons: "close"
            });
        });
    }

    toggleLoadingDialog(show) {
        this.countGridLoading += show? 1: -1;

        if (show) {
            context.message({
                show: true,
                type: "loading",
                message: "Loading. Please wait..."
            });
        }
        else if (this.countGridLoading <= 0) {
            context.message({ show: false });
            this.countGridLoading = 0;
        }
    }


    render() {
        let logs = this.state.pendingDocumentLogs;
        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 ap-text-center ap-mb-2">
                            <h2><b>Documents</b></h2> 
                            <b>Below are your tasks for uploading, reviewing and signing documents.</b>                                                          
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 ap-text-left">
                            <i className="fa fa-folder"></i>
                            <span className="ap-h3 ap-ml-1">Pending E-Sign & Upload Documents</span>  
                            <div className="ap-ml-2 ap-mb-1">{`${logs.length} Requests`}</div>                              
                        </div>
                    </div>
                                            
                        {
                            logs && logs.length > 0 ?
                            logs.map(log => {
                                let titles = log.documents.map(d => d.title).join(", ");    
                                let imgSrc = log.type == "UPLOAD" ? context.url("images/Upload.svg") : context.url("images/E-Sign.svg");
                 
                                return (
                                    <Fragment key={log.logId}>
                                    <div className="row ap-ml-2">
                                        <div className="col-md-9 ap-text-left ap-pl-0">        
                                            <img src={imgSrc} className="ap-people-document-img"/>
                                            <PeopleDocumentTitle title={titles}></PeopleDocumentTitle>                                                                    
                                            <p className="ap-people-documents-sub-text">Requested on {moment(log.sentDate).format("YYYY-MM-DD HH:mm A")}</p>                                                                                                                                  
                                        </div>
                                        <div className="col-md-3 ap-text-right">
                                            <a className="button btn btn-selected ap-pending-documents-btn" target="_blank" href={log.documents[0].processLink}>{log.type == "ESIGN" ? "Review and Sign" : "Upload"}</a>                                            
                                        </div>
                                        
                                    </div>
                                    <hr className="ap-mt-0 ap-mb-0"/>
                                    </Fragment>

                                );
                            }) : null }                            
                    
                </div>
            </div>
        );
    }
}